import { NotifyData } from 'domain/entities/NotifyEntity';
import { ListNoData } from 'presentation/components/ListNoData';
import { CardComponent } from '../components/Card';
interface props {
    listNotify: NotifyData[];
    handleScroll: (e: any) => void;
    putNotice: (id: number) => void;
}

const NotifyList = ({ listNotify, handleScroll, putNotice }: props) => {
    return (
        <div
            style={{
                width: '100%',
                height: '100%',
                display: 'flex',
                flexFlow: 'column',
                textAlign: 'center',
                overflow: 'auto',
            }}
            onScroll={handleScroll}
        >
            {listNotify.length > 0 ? (
                <section className="wrapper-card">
                    <div style={{ width: '100%' }}>
                        <div className="grid-container">
                            {listNotify.map((element: NotifyData, index: number) => (
                                <CardComponent key={index} data={element} onClick={putNotice} />
                            ))}
                        </div>
                    </div>
                </section>
            ) : (
                <ListNoData title="データはありません" isDisplayIcon={false} />
            )}
        </div>
    );
};

export default NotifyList;
